import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { BehaviorSubject, debounceTime, Observable, switchMap, tap } from 'rxjs';
import { BandiFilters, BandiResponse, FilterOption, ObiettivoEuropaService } from '../services/obiettivo-europa.service';
import { BandoCardComponent } from './bando-card/bando-card.component';
import { BandoItemComponent } from './bando-item/bando-item.component';
import { CarouselModule } from '@marcreichel/angular-carousel';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { RoutingService } from '../services/routing.service';


@Component({
  selector: 'app-obiettivo-europa-list',
  templateUrl: './obiettivo-europa-list.component.html',
  styleUrls: ['./obiettivo-europa-list.component.scss'],
  standalone: true,
  imports:[
    CommonModule,
    BandoCardComponent,
    BandoItemComponent,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatButtonToggleModule,
    FormsModule,
    ReactiveFormsModule,
    MatPaginatorModule,
    CarouselModule,
  ]
})
export class ObiettivoEuropaListComponent  implements OnInit {

  sectors$!: Observable<FilterOption[]>;
  beneficiaries$!: Observable<FilterOption[]>;
  types$!: Observable<FilterOption[]>;
  regions$!: Observable<FilterOption[]>;
  programs$!: Observable<FilterOption[]>;

  @Input() filters: boolean = true;
  @Input() layout: 'carousel' | 'list' | 'grid'= 'list';

  // sectors$!: Promise<FilterOption[]>;
  // beneficiaries$!: Promise<FilterOption[]>;
  // types$!: Promise<FilterOption[]>;
  // regions$!: Promise<FilterOption[]>;
  // programs$!: Promise<FilterOption[]>;
  
  filterForm!: FormGroup;
  public filtersSubject = new BehaviorSubject<BandiFilters>({
    page: 1,
    ordering: '-published'
  });

  loading = false;
  
  statusOptions = [
    { value: null, label: 'Tutti' },
    { value: 1, label: 'Aperti' },
    { value: 2, label: 'In uscita' }
  ];
  
  orderingOptions = [
    { value: '-published', label: 'Pubblicazione: più recente' },
    { value: 'published', label: 'Pubblicazione: meno recente' },
    { value: 'deadline', label: 'Scadenza: crescente' },
    { value: '-deadline', label: 'Scadenza: decrescente' }
  ];
  
  public pageSubject = new BehaviorSubject<number>(1);
  currentPage$ = this.pageSubject.asObservable();
  
  bandiResponse$!: Observable<BandiResponse>;
  error: string | null = null;
  
  constructor(
    private bandiService: ObiettivoEuropaService,
    private fb: FormBuilder,
    // private router: Router,
    private routingService: RoutingService,
    
  ) {
    this.initializeForm();
    this.loadFilterOptions();
    
  }

  getFormField(name: string) : FormControl {
    return this.filterForm.controls[name] as FormControl;
  }

  private initializeForm() {
    this.filterForm = this.fb.group({
      search: [''],
      sectors: [[]],
      beneficiaries: [[]],
      types: [[]],
      regions: [[]],
      programs: [[]],
      status: [null],
      ordering: ['-published'],
      showFavorites: [false]
    });

    // Subscribe to form changes
    this.filterForm.valueChanges.pipe(
      debounceTime(300)
    ).subscribe(filters => {
      this.updateFilters({ ...filters, page: 1 });
    });
  }

  private loadFilterOptions() {
    this.sectors$ = this.bandiService.getSectors();
    this.beneficiaries$ = this.bandiService.getBeneficiaries();
    this.types$ = this.bandiService.getTypes();
    this.regions$ = this.bandiService.getRegions();
    this.programs$ = this.bandiService.getPrograms();
  }

  private setupDataStream() {
    this.bandiResponse$ = this.filtersSubject.pipe(
      tap(() => this.loading = true),
      switchMap(filters => this.bandiService.getBandi(filters)),
      tap(() => this.loading = false)
    );
  }

  updateFilters(filters: Partial<BandiFilters>) {
    this.filtersSubject.next({
      ...this.filtersSubject.getValue(),
      ...filters
    });
  }

  resetFilters() {
    this.filterForm.reset({
      search: '',
      sectors: [],
      beneficiaries: [],
      types: [],
      regions: [],
      programs: [],
      status: null,
      ordering: '-published',
      showFavorites: false
    });
  }

  onPageChange(page: number) {
    this.updateFilters({ page });
    this.pageSubject.next(page);
  }

  saveSearch() {
    // Implement save search functionality
    console.log('Current filters:', this.filtersSubject.getValue());
  }

  ngOnInit(): void {
    this.setupDataStream();
  }

  // onPageChange(page: number): void {
  //   this.pageSubject.next(page);
  // }

  onFavoriteToggle(bandoId: number): void {
    this.bandiService.toggleFavorite(bandoId).subscribe();
  }

  trackByBandoId(index: number, bando: any): number {
    return bando.id;
  }

  goToBandi(event: any) {
    // this.router.navigate([environment.routingBasePath + '/product/obiettivo-europa']);
    this.routingService.navigate([environment.routingBasePath + '/product/obiettivo-europa']);

  }

  
}